import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) Redução da quantidade de pessoas na operação da planta",
    correct: false,
  },
  {
    option: "b) Aumento da eficiência e estabilidade do processo",
    correct: true,
  },
  {
    option:
      "c) Melhoria na transferência de conhecimento entre especialistas de processo",
    correct: false,
  },
  {
    option: "d) Aumento do consumo de matéria-prima e energia no processo",
    correct: false,
  },
  {
    option: "e) Aumento da velocidade do processo",
    correct: false,
  },
];

export default function Question19(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question19: {
          title: "Quais os principais ganhos de um sistema especialista?",
          option: option.option,
          correct: option.correct,
          order: 19
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t("Quais os principais ganhos de um sistema especialista?")}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
